import React, { useState, useEffect } from "react";
import { useGlobalState } from "../contexts/GlobalStateContext";
import { clearAllCookies } from "../Helpers/cookieUtils";
import FollowButton from "./Follow";
import ShowLinkModal from "./ShowLinkModal";
import ProfileMenu from "./ProfileMenu";
import ProfileOptionsModal from "./ProfileOptionsModal";
import MessageModal from "./MessageModal";
import UpdateTitleModal from "./UpdateTitleModal";
import UpdateAboutModal from "./UpdateAboutModal";
import UpdateThoughtsModal from "./UpdateThoughtsModal";

const UserProfile = ({ data }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  // State to manage visibility of content
  const { globalState, setShowUserInfo, resetGlobalState, setShowLogins } =
    useGlobalState();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [context, setContext] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [coverImageLoaded, setCoverImageLoaded] = useState(false);
  const [visitLink, setVisitLink] = useState(null);
  const [showProfileOptions, setShowProfileOptions] = useState(false);
  const [selectedConvo, setSelectedConvo] = useState(null);
  const avatarVersion = data.avatar_version || 1;
const coverVersion = data.coverImg_version || 1;
  const handleShowLink = (link) => {
    setVisitLink(link);
  };

  const handleClose = () => {
    setVisitLink(null);
  };
  const profileMenu = (context) => {
    setContext(context);
    setShowProfileMenu(true);
  };

  const logOut = () => {
    fetch(`${baseUrl}/php/logout.php`, {
      method: "GET", // or "POST" depending on your server
      credentials: "include", // Include cookies if using session-based authentication
    })
      .then((response) => response.json()) // Assuming the PHP script returns JSON
      .then((data) => {
        resetGlobalState(); // Clear global state
        clearAllCookies();
      })
      .catch((error) => console.error("Logout Error:", error));
  };

  const openConversation = (user_id, fullName) => {
    if (!globalState.isAuthenticated) {
      setShowLogins(true);
      return;
    }
    const currentUserId = globalState.user.user_id;

    const conversation_id =
      user_id < currentUserId
        ? `${user_id}-${currentUserId}`
        : `${currentUserId}-${user_id}`;

    const convo = {
      conversation_id: conversation_id,
      user_id: user_id,
      fullName: fullName,
    };

    setSelectedConvo(convo);
  };

  const handleCloseModal = () => {
    setSelectedConvo(null);
  };

  // Toggle the content visibility when button is clicked (only on mobile)
  const toggleContent = () => {
    setShowUserInfo(!globalState.showUserInfo);
  };

  // Handle image error
  const handleImageError = (event) => {
    if (event.target.src.includes("cover")) {
      event.target.src = "cover/default.jpg";
    } else {
      event.target.src = "profile_pics_icons/default.jpg";
    }
  };

  // Handle cover image load
  const handleCoverImageLoad = () => {
    setCoverImageLoaded(true);
  };

  const formatDateToMonthYear = (dateStr) => {
    const date = new Date(dateStr);
    return `${date.toLocaleString("default", {
      month: "short",
    })} ${date.getFullYear()}`;
  };

const formatUsername = (username) => {
  if (!username) return "";

  const parts = username.split("-");
  if (parts.length < 3) return username;

  const [campRaw, sectorRaw, hutRaw] = parts;

  const camp = (
    campRaw.charAt(0).toUpperCase() +
    campRaw.slice(1).toLowerCase()
  ).replace(/(?<=\D)(?=\d)/g, " ");

  const sector = sectorRaw
    .toUpperCase()
    .replace(/^([A-Z])(\d+).*/, "$1$2");

  const hut = hutRaw.replace(/\D/g, "");

  return `${camp} ${sector} ${hut}`;
};

  const joinDateFormatted = formatDateToMonthYear(data.created_at);
  const [showUpdateTitle, setShowUpdateTitle] = useState(false);
  const [showUpdateAbout, setShowUpdateAbout] = useState(false);
  const [showUpdateThoughts, setShowUpdateThoughts] = useState(false);
  const [showBigProfilePicture, setShowBigProfilePicture] = useState(false);
  return (
    <>
    {showBigProfilePicture && (
  <div id="showLink" className="showLinkBox" style={{ display: "block" }}>
    <div className="showNotice" style={{ padding: "25px 3px 0px 3px" }}>
      <span
        className="close"
        onClick={() => setShowBigProfilePicture(false)}
        role="button"
        tabIndex={0}
        aria-label="Close modal"
        onKeyDown={(e) => {
          if (e.key === 'Escape' || e.key === ' ') {
            setShowBigProfilePicture(false);
          }
        }}
      >
        &times;
      </span>
      <div style={{ margin: "5px", textAlign: "center" }}>
        <img
          /* FIX: Use data.avatar_version instead of globalState.user */
          src={`/profile_pics/${data.user_id}.jpg?v=${data.avatar_version || 1}`}
          alt="Profile full size"
          style={{ width: "100%", maxWidth: "500px", height: "auto" }}
          onError={handleImageError}
        />
      </div>
    </div>
  </div>
)}
      {showUpdateTitle && (<UpdateTitleModal
        onClose={() => setShowUpdateTitle(false)}
      />)}
      {showUpdateAbout && (<UpdateAboutModal
        onClose={() => setShowUpdateAbout(false)}
      />)}
      {showUpdateThoughts && (<UpdateThoughtsModal
        onClose={() => setShowUpdateThoughts(false)}
      />)}
      {selectedConvo && (
        <MessageModal convo={selectedConvo} onClose={handleCloseModal} />
      )}
      {showProfileOptions && (
        <ProfileOptionsModal
          user={data.username}
          userId={data.user_id}
          onClose={() => setShowProfileOptions(false)}
        />
      )}
      <div>
        {showProfileMenu && (
          <ProfileMenu
            context={context}
            onClose={() => setShowProfileMenu(false)}
          />
        )}
        <ShowLinkModal visitLink={visitLink} onClose={handleClose} />
        {/* Collapsible button to toggle content visibility */}
      <button
        className={`collapsible ${globalState.showUserInfo ? "active" : ""}`}
        id="cProfile"
        onClick={toggleContent}
        style={{
          backgroundImage: `url(/cover/${data.user_id}.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "#fff", // optional: text color
        }}
      >
        {data.country || ""}
      </button>


        {globalState.isAuthenticated &&
          globalState.showUserInfo &&
          data.self &&
          !globalState.viewAsPublic ? (
          //private content
          <>
            <div>
              {/* Profile Menu */}
              <div className="profileMenu">
                <button
                  className="profile_menu"
                  onClick={() => profileMenu("settings")}
                >
                  Settings
                </button>
                <button
                  className="profile_menu"
                  onClick={() => profileMenu("privacy")}
                >
                  Privacy
                </button>
                <button
                  className="profile_menu"
                  onClick={() => profileMenu("adManager")}
                >
                  Good Wishes
                </button>
                <button
                  className="profile_menu"
                  onClick={() => profileMenu("support")}
                >
                  Support
                </button>
                <button
                  id="log_out"
                  className="profile_menu"
                  style={{ fontWeight: "bold" }}
                  onClick={logOut}
                >
                  Log Out
                </button>
              </div>

              {/* Cover Section */}
              <div id="cover" className="cover">
                <img
                  src={`/cover/${data.user_id}.jpg?v=${globalState.user.coverImg_version}`}
                  alt="Cover Image"
                  className="thumbnail"
                  onLoad={handleCoverImageLoad}
                  onError={handleImageError}
                />

                {coverImageLoaded && (
                  <>
                    <div className="top-left">
                      <img
                        id="dp"
                        className="dp"
                        width="30px"
                        src={`/profile_pics_icons/${data.user_id}.jpg?v=${globalState.user.avatar_version}`}
                        alt="Profile"
                        onClick={() => setShowBigProfilePicture(true)}
                      />
                      <span id="username" style={{ backgroundColor: globalState.user.theme || "#333", color: globalState.user.text_bg, padding: '0 5px' }}>{formatUsername(globalState.user.username)}</span>
                    </div>

                    <div className="top-right" >
                      <span id="noOfPosts" style={{ backgroundColor: globalState.user.theme || "#333", color: globalState.user.text_bg, marginRight: '5px' }}>
                        {globalState.user.noOfPosts || 0} Members
                      </span>
                      <div
                        style={{
                          backgroundColor: globalState.user.theme,
                          borderRadius: '9999px',
                          padding: '3.5px 0px', // Reduced padding for a smaller icon
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: globalState.user.text_bg,
                        }}
                        onClick={() => {
                          setShowProfileOptions(true);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20" // Reduced SVG size
                          height="20" // Reduced SVG size
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="1"></circle>
                          <circle cx="12" cy="5" r="1"></circle>
                          <circle cx="12" cy="19" r="1"></circle>
                        </svg>
                      </div>

                    </div>

                    <div className="bottom-right" style={{ backgroundColor: globalState.user.theme || "#333", color: globalState.user.text_bg }}>
                      <span
                        id="c"
                        alt="Message"
                        onClick={() =>
                          openConversation(globalState.user.user_id, globalState.user.fullName)
                        }
                      >Message</span>
                    </div>

                    <div className="centered">
                      <span
                        id="abvri"
                        className="abvri2"
                        style={{ color: globalState.user.theme || "red" }}
                      >
                        {globalState.user.initials || "UN"}
                      </span>
                      <br />
                      <span
                        id="fullForm"
                        className="fullForm5"
                        style={{
                          color: globalState.user.theme || "red",
                          backgroundColor: globalState.user.text_bg || "white",
                        }}
                      >
                        {globalState.user.fullName || "USER NAME"}
                      </span>
                    </div>

                    <FollowButton user={data} />

                    {globalState.user.link && (
                      <span
                        className="link"
                        id="personal_link"
                        onClick={() => handleShowLink(globalState.user.link)}
                      >
                        &#128279;
                      </span>
                    )}
                  </>
                )}
              </div>
              {/* Bio Section */}
              <div id="bio-container">
                <div id="bio" onClick={() => setShowUpdateTitle(true)}>
                  {globalState.user.title || "Status"} {/* Sanitize title */}
                </div>
              </div>

              {/* Thoughts Section */}
              <div id="thoughts-container">
                <div id="thoughts">
                  Currently, on our minds... <br />
                  <p>
                    {globalState.user.thoughts || "Click on the pen to edit."}
                  </p>{" "}
                  {/* Sanitize thoughts */}
                  <span className="edit-icon" onClick={() => setShowUpdateThoughts(true)}>
                    &#9998;
                  </span>
                </div>
              </div>

              {/* About Section */}
              <div id="about-container">
                <div id="about">
                  About Us <br />
                  <p align="left">
                    {globalState.user.aboutMe || "Click on the pen to edit."}
                  </p>{" "}
                  {/* Sanitize aboutMe */}
                  <span className="edit-icon" onClick={() => setShowUpdateAbout(true)}>
                    &#9998;
                  </span>
                </div>
              </div>
            </div>
          </>
        ) : globalState.showUserInfo &&
          (!data.self || globalState.viewAsPublic) ? (
          //public content
          <div className="content">
            <div
              id="memberStatus"
              className="btn btn-arrow-left btn-arrow-right"
            >
              Registered On: {joinDateFormatted}
            </div>

            <div className="cover">
              <img
                src={`/cover/${data.user_id}.jpg?v=${data.coverImg_version}`}
                alt="Cover Image"
                className="thumbnail"
                onLoad={handleCoverImageLoad} // Trigger cover image load
                onError={handleImageError}
              />

              {/* Conditionally render content after cover image has loaded */}
              {coverImageLoaded && (
                <>
                  <div className="top-left">
                    <img
                      id="dp"
                      className="dp"
                      width="30px"
                      src={`/profile_pics_icons/${data.user_id}.jpg?v=${data.avatar_version}`}
                      alt="Profile Image"
                      onClick={() => setShowBigProfilePicture(true)}
                      onError={handleImageError}
                    />
                    <span id="username" style={{ backgroundColor: data.theme || "#333", color: data.text_bg, padding: '0 5px' }}>
                      {formatUsername(data.username)}
                      {/* Sanitize username */}
                    </span>
                  </div>
                 <div className="top-right" >
                      <span id="noOfPosts" style={{ backgroundColor: data.theme || "#333", color: data.text_bg, marginRight: '5px' }}>
                        {data.noOfPosts || 0} Members
                      </span>
                      <div
                        style={{
                          backgroundColor: data.theme,
                          borderRadius: '9999px',
                          padding: '3.5px 0px', // Reduced padding for a smaller icon
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: data.text_bg,
                        }}
                        onClick={() => {
                          setShowProfileOptions(true);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20" // Reduced SVG size
                          height="20" // Reduced SVG size
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="1"></circle>
                          <circle cx="12" cy="5" r="1"></circle>
                          <circle cx="12" cy="19" r="1"></circle>
                        </svg>
                      </div>

                    </div>
                  <div className="bottom-right" style={{ backgroundColor: data.theme || "#333", color: data.text_bg }}>
                    <span
                      id="c"

                      alt="Message Icon"
                      onClick={() =>
                        openConversation(data.user_id, data.fullName)
                      }
                    >Message</span>
                  </div>
                  <div className="centered">
                    <span
                      id="abvri"
                      className="abvri2"
                      style={{ color: data.theme || "red" }}
                    >
                      {data.initials || "UN"} {/* Sanitize initials */}
                    </span>
                    <br />
                    <span
                      id="fullForm"
                      className="fullForm5"
                      style={{
                        color: data.theme || "red",
                        backgroundColor: data.text_bg || "white",
                      }}
                    >
                      {data.fullName || ""} {/* Sanitize full name */}
                    </span>
                  </div>
                  <FollowButton user={data} />
                  {data.link && (
                    <span
                      className="link"
                      id="personal_link"
                      onClick={() => handleShowLink(data.link)}
                    >
                      &#128279;
                    </span>
                  )}
                </>
              )}
            </div>

            {/* Bio Section */}
            <div id="bio-container">
              <div id="bio" style={{ cursor: "default" }}>
                {data.title || ""} {/* Sanitize title */}
              </div>
            </div>

            {/* Thoughts Section */}
            <div id="thoughts-container">
              <div id="thoughts">
                Currently, on our minds... <br />
                <p>{data.thoughts || "Not Available"}</p>{" "}
                {/* Sanitize thoughts */}
              </div>
            </div>

            {/* About Section */}
            <div id="about-container">
              <div id="about">
                About Us <br />
                <p align="left">{data.aboutMe || "Not Available"}</p>{" "}
                {/* Sanitize aboutMe */}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default UserProfile;
